import _ from "lodash";

export const isActionZoneAlert = (actionZone, actionZoneId) => {
    if (actionZoneId > 0) {
        if (actionZone) {
            var az = _.find(actionZone, function (dcAZ) { return dcAZ.Id === actionZoneId; });
            if (az) {
                return az.IsAlertOnEnter;  // TBD add other alerts type when available
            }
        }
    }
    return false;
}